module.exports = __webpack_public_path__ + "img/smileyrouge_off.97d6b819.gif";